module.exports = __webpack_public_path__ + "img/tervezhetoseg_kep_372.0a2e7ca7.png";